export interface MockPurchaseLine {
  quantity: number;
  name: string;
  note?: string;
  orders: { number: number; quantity: number }[];
}

export interface MockPurchaseDay {
  label: string;
  deliverOn: string;
  daysAhead: number;
  lines: MockPurchaseLine[];
}

const orders = (...pairs: [number, number][]) =>
  pairs.map(([number, quantity]) => ({ number, quantity }));

export const MOCK_PURCHASE_DAYS: MockPurchaseDay[] = [
  {
    label: 'Mardi 25 août',
    deliverOn: 'lundi soir',
    daysAhead: 1,
    lines: [
      {
        quantity: 12,
        name: 'Huîtres de Zélande n°3',
        orders: orders([118, 6], [121, 4], [124, 2]),
      },
      {
        quantity: 8,
        name: 'Moules de Zélande',
        orders: orders([119, 5], [122, 3]),
      },
      {
        quantity: 2,
        name: 'Homard breton 500 g',
        note: 'vivant',
        orders: orders([121, 2]),
      },
      {
        quantity: 1,
        name: 'Plateau de fruits de mer',
        note: 'pour six',
        orders: orders([124, 1]),
      },
    ],
  },
  {
    label: 'Mercredi 26 août',
    deliverOn: 'mardi soir',
    daysAhead: 2,
    lines: [
      {
        quantity: 10,
        name: 'Saumon fumé en plaque',
        orders: orders([126, 6], [129, 4]),
      },
      {
        quantity: 6,
        name: 'Truites saumonées',
        note: 'en filets',
        orders: orders([127, 6]),
      },
      { quantity: 2, name: 'Caviar belge 50 g', orders: orders([129, 2]) },
    ],
  },
  {
    label: 'Jeudi 27 août',
    deliverOn: 'mercredi soir',
    daysAhead: 3,
    lines: [
      {
        quantity: 9,
        name: 'Gambas 4/6',
        note: 'dont 4 décortiquées',
        orders: orders([131, 5], [133, 4]),
      },
      { quantity: 4, name: 'Bisque de homard', orders: orders([133, 4]) },
    ],
  },
  {
    label: 'Lundi 31 août',
    deliverOn: 'dimanche soir',
    daysAhead: 7,
    lines: [
      {
        quantity: 6,
        name: 'Bar de ligne',
        orders: orders([140, 4], [142, 2]),
      },
      { quantity: 3, name: 'Tourteau', orders: orders([142, 3]) },
    ],
  },
  {
    label: 'Lundi 7 septembre',
    deliverOn: 'dimanche soir',
    daysAhead: 14,
    lines: [
      {
        quantity: 20,
        name: 'Huîtres de Zélande n°3',
        orders: orders([150, 12], [151, 8]),
      },
    ],
  },
];
